import { Component } from 'react';
import axios from 'axios';
import Header from '../Header';
import { Accordion, Card } from "react-bootstrap";
import parse from 'html-react-parser';
import LoadingScreen from '../common/loading-screen';
import TableHeaderBenefits from '../common/table-header';

import { HEARTIST_BENEFITS, HEARTIST_EMAIL_CHECK } from '../../constants/index';
import { validEmail, validFromOctober2025 } from '../helper';

import '../../css/style.css';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            errorMessage: "",
            isValidEmail: true,
            isLoading: false,
            emailSent: false,
            country: props.country
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.country !== this.props.country) {
            this.setState({ country: this.props.country });
        }
    }

    handleInputChange = (e) => {
        this.setState({
            email: e.target.value,
            isValidEmail: true,
            errorMessage: ""
        });
    };

    handleSubmit = async () => {
        const { email } = this.state;

        this.setState({ isLoading: true });

        if (!email) return this.setError("Email address is required.");
        if (!validEmail(email)) return this.setError("Email address not valid.");

        try {
            const response = await axios.post(HEARTIST_EMAIL_CHECK, { email: email, country: this.state.country });
            const { status, data } = response;

            if (status === 200) {
                if (data.coupon_code) {
                    this.setState({
                        emailSent: true,
                        errorMessage: ""
                    });
                } else {
                    this.setError("ErrorCode (1048): This coupon code has been used. Please contact our <a href='https://help.accorplus.com/hc/en-au'>Member Services</a> team if you need assistance.");
                }
            }

            this.setState({ isLoading: false });
        } catch (err) {
            const status = err?.response?.status;
            const message = this.mapErrorMessage(status, err);
            console.log(err);

            this.setState({
                isValidEmail: false,
                errorMessage: message,
                isLoading: false
            });
        }
    };

    setError(message) {
        this.setState({
            isLoading: false,
            isValidEmail: false,
            errorMessage: message
        });
    }

    mapErrorMessage(status, err) {
        switch (status) {
            case 400:
                return (
                    err?.response?.data?.error ||
                    `We can't seem to proceed.<br/>Our record shows that the email address provided is not valid.`
                );
            case 401:
                return (
                    err?.response?.data?.error ||
                    `We can't seem to proceed.<br/>Please contact our Member Services team at <a href='mailto:members.singapore@accorplus.com' target='_blank'>members.singapore@accorplus.com</a> for further assistance.`
                );
            case 402:
                return (
                    err?.response?.data?.error ||
                    `We can't seem to proceed.<br/>If you require further assistance, please contact our Member Services team at <a href='mailto:members.singapore@accorplus.com' target='_blank'>members.singapore@accorplus.com</a>`
                );
            default:
                return (
                    err?.response?.data?.error ||
                    "Something went wrong. Please try again later."
                );
        }
    }

    render() {
        const { errorMessage, isValidEmail, isLoading } = this.state;
        let new_benefits;

        if (HEARTIST_BENEFITS) {
            new_benefits = HEARTIST_BENEFITS.map((item, index) =>
                <Card key={index} className="benefits">
                    <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                        <div className="row d-flex ">
                            <div className="mb-0 col-10 col-md-11 accordion-title-text">
                                {item.title}
                            </div>
                            <div className="mb-0 col-2 col-md-1">
                                <img alt="plus-symbol" src="/images/plus-symbol.png" width="22" />
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                            <div className="row">
                                <div className="col-12">
                                    {parse(item.description)}
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            );
        };

        var errrorClass = "";
        if (!isValidEmail) {
            errrorClass = "validation-error"
        }

        return (
            <div className="hotelSales-wrapper">
                <Header
                    handleLeaderBoard={this.handleLeaderBoard}
                    bannerClass="banner-heartist"
                    bannerText={"The Upgrade Your Travels Deserve"}
                />

                <div className="container">
                    <div className="mt-5 container">
                        <h2>Exclusive Heartist Offer: 20% Off an ALL Accor+ Explorer Membership</h2>
                        <p>Designed for the explorer at heart, ALL Accor+ Explorer is your passport to exclusive access, elevated benefits, and recognition that distinguishes every journey.</p>
                    </div>

                    <TableHeaderBenefits tableTitle={validFromOctober2025("ALL ACCOR+ EXPLORER BENEFITS")} />

                    <div className="container accordion-container mt-3 benefits-container mb-5">
                        <Accordion defaultActiveKey="0">
                            {new_benefits}
                        </Accordion>
                    </div>

                    <div className="container">
                        <h5 className={`px-0 py-3 ${this.state.emailSent ? "text-center" : ""}`}>
                            {this.state.emailSent && (
                                <>
                                    Thank you, an email has been sent to your inbox regarding next steps. <br />
                                    Please note, the registration link is valid for 7 days.
                                </>
                            )}

                            {!this.state.emailSent && "Enter your work email address to receive your exclusive Heartist offer"}
                        </h5>

                        <div className="py-3">
                            {!isValidEmail && (<div className="mb-4 text-bold text-center">{parse(errorMessage)}</div>)}

                            {!this.state.emailSent && (
                                <>
                                    <input
                                        type="text"
                                        className={`email-check-input ${errrorClass}`}
                                        placeholder="Enter email"
                                        onChange={this.handleInputChange}
                                    />

                                    <button
                                        className="email-check-input-submit btn btn-primary mt-2 button theme-primary"
                                        onClick={this.handleSubmit}
                                    >
                                        Submit
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="icon"
                                        >
                                            <path d="M17.42 10l-6.951-6.95-1.326 1.325 4.687 4.688H2.97v1.874H13.83l-4.687 4.688 1.326 1.326L17.419 10z"></path>
                                        </svg>
                                    </button>
                                </>
                            )}

                            {isLoading && (<LoadingScreen/>)}
                        </div>
                    </div>

                    <div className="container terms_conditions mt-4">
                        <p className="title"><strong>Terms and conditions:</strong></p>

                        <ol>
                            <li>This offer is open to employees, friends and family of Accor Plus and Accor Heartists</li>
                            <li>Offer is available for new members only</li>
                            <li>The member must register via the dedicated Heartist Friends and Family landing page to receive the 20% off Friends and Family offer</li>
                            <li>The offer is available for purchase in local currency. Purchase with ALL Accor Reward points is not available for this offer</li>
                            <li>Eligible members are entitled to a 12-month ALL Accor+ Explorer membership</li>
                            <li>
                                Standard terms and conditions governing the use of an ALL Accor+ Explorer membership apply.
                                Please view the ALL Accor+ Explorer membership terms and conditions{" "}
                                <a
                                    href="https://www.accorplus.com/about/terms-and-conditions/?utm_medium=email&utm_source=HeartistFamFriends&utm_campaign=HearistFamFriends_Paymentlink"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    here
                                </a>{" "}
                                for more details. Terms and conditions are subject to change without prior notice.
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        );
    }
}

export default (Home);